/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
export type IntegrationCreateClientPayload = {
    gender: IntegrationCreateClientPayload.gender;
    firstName: string;
    lastName: string;
    email?: string;
    phoneNumber?: string;
    address?: Address;
};
export namespace IntegrationCreateClientPayload {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

